import { ItemInfo } from "@/components/commons/ItemInfo";
import { InnerBox } from "@/components/elements/InnerBox";
import { CompanyFormTitle } from "@/features/company/components/company-info/CompanyFormTitle";
import { TGetRSODto } from "@/api/services/main/rso/dtos/get-rso.dto";
import { FCC } from "@/types/common";
import { Box, Divider, Grid, Stack, Typography } from "@mui/material";
import { IconErrorOutline } from "@/assets/icons";
import { black, text } from "@/theme/colors";
import { Tooltip } from "@/components/elements/Tooltip";
import { formatRSOId } from "@/utils/number";

type TRsoBasicInfoSectionProps = {
  data: Partial<TGetRSODto>;
};

export const RsoBasicInfoSection: FCC<TRsoBasicInfoSectionProps> = ({ data }) => {
  return (
    <InnerBox title={<CompanyFormTitle text="基本情報" />} showDivider={false}>
      <Grid container spacing={3} mt={-2}>
        <Grid item xs={12}>
          <Stack direction="row" alignItems="center" spacing={0.5}>
            <Typography variant="cap12Light">組織ID</Typography>
            <Tooltip title="" content="お客様の固有識別番号(ID)です。ログイン時やお問い合わせ時に使用されることがございます。">
              <Box component="span" sx={{ display: "inline-flex", verticalAlign: "middle", lineHeight: 0 }}>
                <IconErrorOutline width={15} height={15} color={black[80]} />
              </Box>
            </Tooltip>
          </Stack>
          <Typography
            variant="body14Semi"
            color={text.primary}
            sx={{
              fontFamily: "inherit",
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              overflowWrap: "break-word",
            }}
          >
            {formatRSOId(data.id)}
          </Typography>
          <Divider sx={{ marginTop: "8px" }} />
        </Grid>
        <Grid item xs={6}>
          <ItemInfo label="登録支援機関の名称" value={data.name} isShowDivider={false} />
        </Grid>
        <Grid item xs={6}>
          <ItemInfo label="登録番号" value={data.licenseNumber} isShowDivider={false} />
        </Grid>
      </Grid>
    </InnerBox>
  );
};
